<template>
    <div>
        <br>

        <b-table :items="valuesLegenda" :fields="fieldsLegenda" :sortDesc="true" small>
            <template #cell(dia)="data">
                {{ labelsLegenda[data.value] }}
            </template>

            <template #cell(pago_online)="data">
                {{ 'R$ ' + data.value }}
            </template>

            <template #cell(pago_local)="data">
                {{ 'R$ ' + data.value }}
            </template>

            <template #cell(pago_total)="data">
                {{ 'R$ ' + data.value }}
            </template>
        </b-table>
    </div>
</template>

<script>

export default {
    component: 'LegendaChartArrecadacao',

    props: {
        legendaChartArrecadacao: {
            type: Object | Array,
            default: { datasets: [], labels: [] }
        },
    },

    computed: {
        labelsLegenda() {
            if (this.legendaChartArrecadacao.labels != undefined && this.legendaChartArrecadacao.labels.length > 0) {
                return this.legendaChartArrecadacao.labels
            }
            return []
        },

        valuesLegenda() {
            if (this.legendaChartArrecadacao.datasets != undefined && this.legendaChartArrecadacao.datasets.length > 0) {

                // Formata e classifica items em Num. de visitantes ou valor pago online/local
                // O primeiro loop roda os items brutos e o segundo loop os valores de cada um
                var dataset = this.legendaChartArrecadacao.datasets.map(function (value, index) {
                    var valores = value.data.map(function (val, idx) {
                        return val
                    })
                    return valores
                })

                // Loop nos labels de datas para juntar em um só array os visitantes e
                // valores pagos pra cada data (o mesmo index da data será o dos valores/visitantes)
                dataset = this.labelsLegenda.map(function (value, index) {
                    var valores = dataset.map(function (val, idx) {
                        return val[index]
                    })

                    return valores
                })

                // Com os valores e visitantes em um mesmo array, sao formatados para aparecerem em uma unica linha
                dataset = dataset.map(function (value, index) {
                    return {
                        dia: index,
                        visitantes: value[0],
                        pago_online: value[1].toFixed(2).replace('.', ','),
                        pago_local: value[2].toFixed(2).replace('.', ','),
                        pago_total: (value[1] + value[2]).toFixed(2).replace('.', ','),
                    }
                })

                return dataset
            }
            return []
        },
    },

    data: () => {
        return {
            fieldsLegenda: [
                { key: "dia", label: "Data" },
                { key: "visitantes", label: "Visitantes" }, { key: "pago_online", label: "Pago na Janoo" },
                { key: "pago_local", label: "Pago no Local" }, { key: "pago_total", label: "Total" }
            ],
        }
    },

    mounted() {
    },

}

</script>